import React from "react";
import { Select } from "antd";
import Icon from "@mdi/react";
import { mdiChevronDown } from "@mdi/js";
import type { SortValue } from "../../../../utils/listingSearchParams";

interface Props {
  total: number;
  sort: SortValue;
  onSortChange: (sort: SortValue) => void;
  showSort?: boolean;
}

const SORT_OPTIONS = [
  { value: "relevance", label: "Relevance" },
  { value: "price_asc", label: "Price: Low to High" },
  { value: "price_desc", label: "Price: High to Low" },
];

export default function ResultsToolbar({ total, sort, onSortChange, showSort = true }: Props) {
  return (
    <div className="v2-listing__toolbar">
      <span className="v2-listing__count">{total.toLocaleString()} results</span>
      {showSort && (
        <div className="v2-listing__sort">
          <span className="v2-listing__sort-label">Sort by</span>
          <Select
            className="v2-listing__sort-select"
            variant="borderless"
            value={sort}
            options={SORT_OPTIONS}
            onChange={onSortChange}
            suffixIcon={<Icon path={mdiChevronDown} size="20px" />}
            popupMatchSelectWidth={false}
          />
        </div>
      )}
    </div>
  );
}
